// Routes match the old Wix site's URLs so existing links & search results keep working
export const PAGE_ROUTES = {
  HOME: "/",
  SHOP: "/shop",
  //One page per shop category: /earrings, /rings... (see SHOP_CATEGORIES)
  CATEGORY: "/:categorySlug",
  PRODUCT: "/product-page/:productSlug",
  ABOUT: "/about",
  CONTACT: "/contact",
  FAQ: "/faq",
  CART: "/cart",
  ORDER_RESULT: "/order/:result",
};

export const getProductRoute = (slug) => (
  PAGE_ROUTES.PRODUCT.replace(":productSlug", slug)
);

// The Wix store categories, in the order of the category photos. A product's Category field lists the ones it's in
// ("Rings, Sterling Silver"). inFilter: shown in the shop page's category filter (as on Wix). Earcuffs kept Wix's /shop-2 URL.
export const SHOP_CATEGORIES = [
  { name: "Earrings", slug: "earrings", image: "earrings", inFilter: true },
  { name: "Rings", slug: "rings", image: "rings", inFilter: true },
  { name: "Necklaces", slug: "necklaces", image: "necklaces", inFilter: true },
  { name: "Bracelets", slug: "bracelets", image: "bracelets", inFilter: false },
  { name: "Accessories", slug: "accessories", image: "accessories", inFilter: true },
  { name: "Sterling Silver", slug: "sterling-silver", image: "sterling-silver", inFilter: false },
  { name: "Earcuffs", slug: "shop-2", image: "earcuffs", inFilter: false },
];

export const getCategoryImage = (category) => (
  `/images/categories/${category.image}.webp`
);

export const CONTACT_DETAILS = {
  FACEBOOK: "https://www.facebook.com/calicoikati/",
  INSTAGRAM: "https://www.instagram.com/calico_ikati/",
  TAPX: "http://www.tap-x.com/",
};

export const ADMIN_PAGE_ROUTES = {
  HOME: "/admin",
  ORDERS: "/admin/orders",
  ORDER: "/admin/orders/:orderID",
  PRODUCTS: "/admin/products",
  PRODUCT: "/admin/products/:productID",
  ANALYTICS: "/admin/analytics",
  ACCOUNT: "/admin/account",
};

export const getAdminOrderRoute = (orderID) => (
  ADMIN_PAGE_ROUTES.ORDER.replace(":orderID", orderID)
);

//"new" opens an empty product form
export const getAdminProductRoute = (productID) => (
  ADMIN_PAGE_ROUTES.PRODUCT.replace(":productID", productID)
);

export const LOADING_STATE = {
  NOT_LOADING: 0,
  LOADING: 1,
  LOADED: 2,
  ERROR: 3,
};

export const LS_ITEM = {
  LOGIN: "ls_1",
  CONTACT_SEND: "ls_2",
  CHECKOUT: "ls_3",
  ORDER_STATUS: "ls_4",
  PRODUCTS: "ls_5",
};

export const LS_ITEM_ADMIN = {
  SUMMARY_LOAD: "lsa_1",
  ORDERS_LOAD: "lsa_2",
  ORDER_LOAD: "lsa_3",
  ORDER_SAVE: "lsa_4",
  EXPORT: "lsa_5",
  PASSWORD_SAVE: "lsa_6",
  PRODUCTS_LOAD: "lsa_7",
  PRODUCT_LOAD: "lsa_8",
  PRODUCT_SAVE: "lsa_9",
  PRODUCT_DELETE: "lsa_10",
  IMAGES_UPDATE: "lsa_11",
};

export const NOTIF_TYPE = {
  STANDARD: 0,
  ERROR: 1,
  SUCCESS: 2,
};

export const PAYMENT_STATUS = {
  PENDING: "Pending",
  PAID: "Paid",
  FAILED: "Failed",
  CANCELLED: "Cancelled",
  REFUNDED: "Refunded",
};

export const FULFILMENT_STATUS = {
  NEW: "New",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
};

export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "North West",
  "Northern Cape",
  "Western Cape",
];
